import { Component, OnInit } from '@angular/core';
import { SessionStorage } from 'ngx-webstorage';
import { Router } from '@angular/router';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { log } from 'util';
import { AppService } from '../../app.service';
import { MsalService } from "@azure/msal-angular";
declare var $: any;
@Component({
  selector: 'app-rm-sidebar',
  templateUrl: './rm-sidebar.component.html',
  styleUrls: ['./rm-sidebar.component.css'],
  animations: [
    trigger('slideInOut', [
      state('in', style({
        transform: 'translate3d(0, 0, 0)'
      })),
      state('out', style({
        transform: 'translate3d(100%, 0, 0)',

      })),
      transition('in => out', animate('400ms ease-in-out')),
      transition('out => in', animate('400ms ease-in-out'))
    ]),
  ]
})
export class RmSidebarComponent implements OnInit {
  @SessionStorage() public user;
  @SessionStorage() public config;
  menuState: any = 'out';
  public navigations: any = [];
  menuClicked: boolean = false;
  mobileNavigations: any = [];
  public currentYear;
  constructor(private router: Router, private appService: AppService,private authService: MsalService) { }

  ngOnInit() {
    const d = new Date();
    this.currentYear = d.getFullYear();
    this.navigations = [
      { title: 'Dashboard', link: '/rm/dashboard' },
      // { title: 'Organizational Report', link: '/rm/organizational-report' },
      // { title: 'My Report', link: '/rm/my-report' },
      { title: 'Projects', link: '/rm/projects' },
      { title: 'Timesheet Approvals', link: '/rm/timeSheetApprovals' },
      { title: 'Timesheet Entry', link: '/rm/timesheet-entry' },
      // { title: 'Delegate', link: '/rm/viewdelegate' },
      { title: 'Notifications', link: '/rm/notification' },
      // { title: 'Planned-Actual', link: '/rm/planed-actual' }
    ];
    // { title: 'Planned V/S Actual', link: '/rm/plannedActual' },

    this.mobileNavigations = [
      { title: 'Dashboard', link: '/rm/dashboard' },
      { title: 'Timesheet Entry', link: '/rm/timesheet-entry', img: 'assets/images/timesheet_mobile.png ' },
      // { title: 'Delegate', link: '/rm/viewdelegate' },
      { title: 'Projects', link: '/rm/projects', img: 'assets/images/projects_mobile.png' },
      { title: 'Notifications', link: '/rm/notification', img: 'assets/images/bell.png' },
      { title: 'Logout', link: '/', img: 'assets/images/logout_mobile.png' }
    ];

    if (this.config.businessUnit === 'accenture') {
      this.navigations.splice(2, 0,
        { title: 'Employees', link: '/rm/employee' }
      );
      this.mobileNavigations.splice(2, 0,
        { title: 'Employees', link: '/rm/employee' }
      );
     }

    if (this.config.businessUnit === 'ipdo' || this.config.businessUnit === 'biologics' || this.config.businessUnit === 'chinateam' || this.config.businessUnit == 'aps') {
      this.navigations.splice(5, 0,
        { title: 'Organizational Report', link: '/rm/organizational-report', img: 'assets/images/timesheet_mobile.png' },
        { title: 'My Report', link: '/rm/my-report' },
        { title: 'Timesheet Report', link: '/rm/timesheet-report' },
      );
      this.mobileNavigations.splice(5, 0,
        { title: 'Organizational Report', link: '/rm/organizational-report', img: 'assets/images/timesheet_mobile.png' },
        { title: 'My Report', link: '/rm/my-report' },
        { title: 'Non Adherence', link: '/rm/non-adherence-list' }
      );
    }
  }

  /**Function to logout*/
  logOut() {
    // this.appService.logOut().subscribe((res) => {
    //   this.router.navigate(['/']);
    // },
    //   (error) => {
    //     this.router.navigate(['/']);
    //   });
    this.authService.logout();
    this.appService.logOut();
  }

  /**Function to hide/visible nav tab*/
  hideSideNavIfOpen(e) {
    if (this.menuState === 'in') {
      if (e.toElement.className == 'navbar-toggle collapsed open-right-sidebar') {
      } else {
        this.menuState = this.menuState === 'out' ? 'in' : 'out';
      }
    }
  }

  /**Function to toggle menu*/
  toggleMenu() {
    // this.menuState = this.menuState === 'out' ? 'in' : 'out';
    this.menuState = 'in';
  }
}



// WEBPACK FOOTER //
// ./src/app/common/rm-sidebar/rm-sidebar.component.ts